import { useEffect, useState } from 'preact/hooks';
import { db, newId, ensureProgress, type Profile } from '../data/db';
import { appState } from '../app/state';

const AVATARS = ['🧙', '🧝', '🦄', '🐉', '🐱', '🦊', '🦁', '🐼', '⭐️', '🌙'];

export function ProfilePicker() {
  const [profiles, setProfiles] = useState<Profile[]>([]);
  const [showNew, setShowNew] = useState(false);
  const [name, setName] = useState('');
  const [avatar, setAvatar] = useState(AVATARS[0]);
  const [ageBand, setAgeBand] = useState<Profile['ageBand']>('6-7');

  useEffect(() => {
    db.profiles.orderBy('createdAt').toArray().then((list) => {
      setProfiles(list);
      if (list.length === 0) setShowNew(true);
    });
  }, []);

  const create = async () => {
    if (!name.trim()) return;
    const profile: Profile = {
      id: newId(),
      name: name.trim().slice(0, 20),
      avatar,
      ageBand,
      createdAt: Date.now(),
      scoreFloor: ageBand === '4-5' ? 20 : ageBand === '6-7' ? 30 : 35,
      toneStrict: ageBand === '8+',
    };
    await db.profiles.put(profile);
    await ensureProgress(profile.id);
    await appState.selectProfile(profile.id);
  };

  return (
    <div class="ws-overlay scrim">
      <div class="ws-panel" style={{ maxWidth: 640 }}>
        <h1 class="ws-h1">Who's playing?</h1>
        <p class="ws-muted">Each wizard has their own quest and progress.</p>

        {profiles.length > 0 && (
          <div class="ws-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))', marginTop: 16 }}>
            {profiles.map((p) => (
              <button key={p.id} class="ws-profile-tile" onClick={() => appState.selectProfile(p.id)}>
                <div class="avatar">{p.avatar}</div>
                <div class="name">{p.name}</div>
                <div class="age">age {p.ageBand}</div>
              </button>
            ))}
            <button class="ws-profile-tile" onClick={() => setShowNew(true)}>
              <div class="avatar">＋</div>
              <div class="name">Add wizard</div>
            </button>
          </div>
        )}

        {showNew && (
          <div class="ws-card" style={{ marginTop: 16 }}>
            <h2 class="ws-h2">New wizard</h2>
            <div class="ws-grid" style={{ gap: 12 }}>
              <input class="ws-input" placeholder="Wizard name" value={name} onInput={(e) => setName((e.target as HTMLInputElement).value)} />
              <div>
                <div class="ws-muted" style={{ marginBottom: 6 }}>Pick an avatar</div>
                <div class="ws-row">
                  {AVATARS.map((a) => (
                    <button
                      key={a}
                      class="ws-btn ghost"
                      style={{ fontSize: 24, padding: '8px 14px', borderColor: a === avatar ? 'var(--accent)' : 'transparent', border: '2px solid', background: a === avatar ? 'var(--accent-2)' : 'transparent' }}
                      onClick={() => setAvatar(a)}
                    >{a}</button>
                  ))}
                </div>
              </div>
              <div>
                <div class="ws-muted" style={{ marginBottom: 6 }}>Age</div>
                <div class="ws-row">
                  {(['4-5', '6-7', '8+'] as const).map((b) => (
                    <button
                      key={b}
                      class="ws-btn ghost"
                      style={{ background: b === ageBand ? 'var(--accent)' : 'rgba(245,239,255,0.08)' }}
                      onClick={() => setAgeBand(b)}
                    >{b}</button>
                  ))}
                </div>
              </div>
              <div class="ws-row between">
                {profiles.length > 0 && <button class="ws-btn ghost" onClick={() => setShowNew(false)}>Cancel</button>}
                <button class="ws-btn big" onClick={create}>Begin quest →</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
